import { getRandomPhoto } from "@/library/flickr";

async function loadBackground() {
  const { url_high, url_low } = await getRandomPhoto();
  document.body.style.setProperty("--background-url-high", `url(${url_high})`);
  document.body.style.setProperty("--background-url-low", `url(${url_low})`);
}

loadBackground();

if (!navigator.onLine) console.warn("Application offline.");
navigator.serviceWorker?.register("sw.js");

console.log(
  "Jurassic Park, System Security Interface\nVersion 4.0.5, Alpha E\nReady...",
);
